
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 import { SkyForm as SkyFormElement, SkyFormChangeDetail, SkyFormFormDataFallbackDetail, SkyFormSubmitDetail, SkyFormValidationErrorsDetail } from '@sky.ui/core/sky-form';
 
 

 
 export const SkyForm = createComponent({
   displayName: 'SkyForm',
   react: React,
   tagName: 'sky-form',
   elementClass: SkyFormElement,
   events: {
     
     onFormChange: 'form-change' as EventName<CustomEvent<SkyFormChangeDetail>>,
     onValidationErrors: 'validation-errors' as EventName<CustomEvent<SkyFormValidationErrorsDetail>>,
     onFormdata: 'formdata' as EventName<CustomEvent<SkyFormFormDataFallbackDetail> | FormDataEvent>,
     onFormSubmit: 'form-submit' as EventName<CustomEvent<SkyFormSubmitDetail>>,
   }
  });
export type * from '@sky.ui/core/sky-form';
